import { useState } from "react";
import { ImageOff } from "lucide-react";
import { useLang } from "../../i18n/LanguageContext";

export const SafeImage = ({ className = "", testId, ...img }) => {
  const { t } = useLang();
  const [failed, setFailed] = useState(false);

  if (failed) {
    return (
      <div className={`img-missing ${className}`} role="img" aria-label={t.missing} data-testid={testId ? `${testId}-missing` : undefined}>
        <ImageOff size={22} strokeWidth={1.3} aria-hidden="true" />
        <span>{t.missing}</span>
      </div>
    );
  }
  return <img className={className} onError={() => setFailed(true)} data-testid={testId} {...img} />;
};
